import React, { useState, useEffect } from "react";
import * as Sentry from "@sentry/react";
// Replaced CSS Modules with Tailwind utility classes applied inline in JSX
import { useSelector, useDispatch } from "react-redux";
import {
  postProfileImage,
  getUserProfile,
  postUserProfile,
  deleteProfile,
} from "../../store/actions/userProfileActions.js";
import { useParams, useNavigate } from "react-router";
import ModalComponent from "../../components/Modals/Modal.js";
import {
  userPaymentMethods,
  setDefaultPaymentMethod,
  deletePaymentMethod,
} from "../../store/actions/paymentActions.js";
import { referAFriend } from "../../store/actions/friendReferralActions.js";
//Modal Imports

import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import { stripeTestPromise } from "../../store/constants/baseUrl.js";
import { handleValidatePhoneNumber } from "../../Utilities/general.js";
import SubHeader from "./SubHeader.jsx";
import ProfileScreenContent from "./ProfileScreenContent";

import FriendReferralsScreenContent from "./FriendReferralsScreenContent";
import PaymentScreenContent from "./PaymentScreenContent.jsx";

const UserProfile = () => {
  // state to restrict multipel clicks
  const [buttonClicked, setButtonClicked] = useState(false);
  const [buttonClicked2, setButtonClicked2] = useState(false);
  const [buttonClicked3, setButtonClicked3] = useState(false);
  // state to display errors
  const [error, seterror] = useState("");

  const [loader, setLoader] = useState(false);
  // state to display success message
  const [success, setsuccess] = useState("");
  //bring labels into text
  const [firstNameToggle, setfirstNameToggle] = useState(true);
  const [cardHolderToggle, setcardHolderToggle] = useState(true);
  const [lastNameToggle, setlastNameToggle] = useState(true);
  const [emailToggle, setemailToggle] = useState(true);
  const [contactNoToggle, setcontactNoToggle] = useState(true);
  const [DOBToggle, setDOBToggle] = useState(false);
  const [stripeloader, setstripeLoader] = useState(false);
  const [changesSavedMessage, setChangesSavedMessage] = useState("");
  const [showModal, setShowModal] = useState(false);

  const { email } = useParams();
  const history = useNavigate();
  // userProfileObj
  const [userObj, setuserObj] = useState();
  // paymentMethodsArr
  const [paymentMethodArr, setpaymentMethodArr] = useState();
  const [cardHolderName, setcardHolderName] = useState("");

  // open delete profile modal
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [addStripe, setAddStripe] = useState(false);

  const handleUpdateProfile = () => {
    try {
      if (!buttonClicked) {
        setButtonClicked(true);
        setDOBToggle(false);
        dispatch(
          postUserProfile(userObj, setChangesSavedMessage, setShowModal)
        );
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

  const handleDeleteProfile = () => {
    dispatch(deleteProfile(userProfileInfo?.id, history, seterror));
    setOpenDeleteModal(false);
  };
  //change screen
  const [changeScreen, setchangeScreen] = useState(0);
  // friend email for referrals
  const [referralEmail, setreferralEmail] = useState("");

  const handleReferAFriend = () => {
    try {
      if (referralEmail === userInfo?.email) {
        seterror("You cannot refer yourself!");
        return;
      }
      const res = ValidateEmail(referralEmail);

      if (res) {
        if (!buttonClicked3) {
          setButtonClicked3(true);
          dispatch(
            referAFriend(
              referralEmail,
              userInfo?.id,
              seterror,
              setsuccess,
              setLoader
            )
          );
          setLoader(true);
        }
        // setreferralEmail("");
      } else {
        setreferral(true);
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

  //Validating Email

  function ValidateEmail(mail) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    }
    return false;
  }
  //upload user profile image
  const handleMediaFileUpload = (e) => {
    try {
      // setimagesToUpload(e?.target?.files);
      console.log(e?.target?.files);
      const formData = new FormData();
      const file = e.target.files[0];
      formData.append(file?.type, file);

      dispatch(
        postProfileImage(
          userObj?.id,
          userObj?.email,
          formData,
          setChangesSavedMessage,
          setShowModal
        )
      );
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

  // make a card default
  const makeDefault = (e, cardId) => {
    try {
      if (e?.target?.checked === true) {
        dispatch(setDefaultPaymentMethod(userObj?.id, cardId));
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };
  // delete card
  const handleDeleteCard = (cardId) => {
    try {
      console.log("func fired");
      dispatch(deletePaymentMethod(userObj?.id, cardId));
      dispatch(getUserProfile(userObj?.email));
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

  // call user profile get API
  useEffect(() => {
    try {
      console.log("getting user profile");
      dispatch(getUserProfile(email));
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  }, []);

  // dispatch actions
  const dispatch = useDispatch();
  // get loginInfo from reducer
  const { userProfileInfo } = useSelector((state) => state?.userProfile);

  // getting user details from reducer
  const { loginInfo } = useSelector((state) => state.loginReducer);

  const [userInfo, setuserInfo] = useState();
  // getting payment info freom reducer
  const { paymentMethodInfo } = useSelector(
    (state) => state?.paymentMethodReducer
  );
  const [referral, setreferral] = useState(false);
  const [Stripeopen, setStripeOpen] = React.useState(false);

  const handleStripeClose = () => setStripeOpen(false);

  const [open, setOpen] = React.useState(false);

  const handleClose = () => setAddStripe(false);

  const handlereferralClose = () => setreferral(false);
  // call user payment methods get API
  useEffect(() => {
    try {
      if (userProfileInfo?.id) {
        dispatch(userPaymentMethods(userProfileInfo?.id));
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  }, [userProfileInfo]);

  useEffect(() => {
    try {
      let makeBtnClickable;

      if (buttonClicked) {
        makeBtnClickable = setTimeout(() => {
          setButtonClicked(false);
        }, 10000);
      }
      return () => clearTimeout(makeBtnClickable);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  }, [buttonClicked]);

  useEffect(() => {
    try {
      let makeBtnClickable2;

      if (buttonClicked2) {
        makeBtnClickable2 = setTimeout(() => {
          setButtonClicked2(false);
        }, 10000);
      }
      return () => clearTimeout(makeBtnClickable2);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  }, [buttonClicked2]);

  useEffect(() => {
    try {
      let makeBtnClickable3;

      if (buttonClicked3) {
        makeBtnClickable3 = setTimeout(() => {
          setButtonClicked3(false);
        }, 10000);
      }
      return () => clearTimeout(makeBtnClickable3);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  }, [buttonClicked3]);
  // populate userObj from redux
  useEffect(() => {
    try {
      if (userProfileInfo) {
        console.log("obj set", userProfileInfo);
        setuserObj(userProfileInfo);
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  }, [userProfileInfo]);

  // function to set userinfo
  useEffect(() => {
    try {
      if (loginInfo) {
        console.log("User is logged in", loginInfo);
        setuserInfo(loginInfo);
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  }, [loginInfo]);

  //populate paymentMethodArr from redux
  useEffect(() => {
    try {
      if (paymentMethodInfo) {
        setpaymentMethodArr(paymentMethodInfo);
        console.log("payment method", paymentMethodInfo);
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  }, [paymentMethodInfo]);

  //Modal styles
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return (
    <>
      <SubHeader userObj={userObj} changeScreen={changeScreen} setchangeScreen={setchangeScreen} />


      <div className="min-h-screen bg-transparent flex justify-center py-8 px-10 font-instrument">
        <ModalComponent
          text={changesSavedMessage}
          openState={showModal}
          closeFunction={() => setShowModal(false)}
          btnText1={"Okay"}
          btnClickFunc1={() => setShowModal(false)}
        />
        <ModalComponent
          text={
            "Are you sure you want to delete your profile?Your profile will be permanently deleted and you will not be able to recover your account."
          }
          openState={openDeleteModal}
          closeFunction={() => setOpenDeleteModal(false)}
          /*
            ModalComponent renders buttons in an order that places prop-2 on the left
            and prop-1 on the right. To show "Yes, I am sure" on the LEFT and
            "Cancel" on the RIGHT while keeping current colors, swap labels, handlers
            and classes here only (no change to ModalComponent itself).
          */
          btnText1={"Cancel"}
          btnClickFunc1={() => setOpenDeleteModal(false)}
          btnText2={"Yes, I am sure"}
          btnClickFunc2={handleDeleteProfile}
          btnClass1="px-4 py-2 rounded-lg text-white font-semibold shadow bg-[var(--primary)]"
          btnClass2="px-4 py-2 rounded-lg border border-[#7876A1] text-[#7876A1] font-semibold bg-transparent"
        />
        <Modal
          open={referral}
          onClose={handlereferralClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          BackdropProps={{ style: { backgroundColor: "rgba(120,118,161,0.5)" } }}
          sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <div className="w-full max-w-sm bg-white rounded-2xl shadow-2xl flex flex-col items-center justify-center p-6 md:p-8 outline-none">
            <h3 className="text-xl md:text-2xl font-bold text-[#211F59] text-center mb-2 w-full">Oops!</h3>
            <p id="modal-modal-description" className="text-base text-[#61607a] text-center mb-4 w-full">Something went wrong. Please check and re-enter the email.</p>
            <button
              className="px-6 py-2 rounded-lg text-white font-semibold shadow bg-[#211F59] hover:bg-[#18164a] transition w-full max-w-[140px] mt-2"
              onClick={async () => {
                handlereferralClose();
                setLoader(false);
              }}
            >
              Ok
            </button>
          </div>
        </Modal>

        {/* //Stripe Token added to backend */}
        <Modal
          open={addStripe}
          onClose={handleStripeClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          BackdropProps={{ style: { backgroundColor: "rgba(120,118,161,0.5)" } }}
          sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <div className="w-full max-w-sm bg-white rounded-2xl shadow-2xl flex flex-col items-center justify-center p-6 md:p-8 outline-none">
            <h3 className="text-xl md:text-2xl font-bold text-[#211F59] text-center mb-2 w-full">Success</h3>
            <p id="modal-modal-description" className="text-base text-[#61607a] text-center mb-4 w-full">Postal Code and CVC verified.</p>
            <button
              className="px-6 py-2 rounded-lg text-white font-semibold shadow bg-[#211F59] hover:bg-[#18164a] transition w-full max-w-[140px] mt-2"
              onClick={async () => {
                handleClose();
                setstripeLoader(false);
              }}
            >
              Ok
            </button>
          </div>
        </Modal>

        <div className="w-full max-w-4xl flex flex-col md:flex-row gap-8 md:gap-12">

          {/* Profile Screen Content */}
          {changeScreen === 0 ? (
            <ProfileScreenContent
              userObj={userObj}
              firstNameToggle={firstNameToggle}
              setfirstNameToggle={setfirstNameToggle}
              lastNameToggle={lastNameToggle}
              setlastNameToggle={setlastNameToggle}
              emailToggle={emailToggle}
              setemailToggle={setemailToggle}
              contactNoToggle={contactNoToggle}
              setcontactNoToggle={setcontactNoToggle}
              DOBToggle={DOBToggle}
              setDOBToggle={setDOBToggle}
              handleMediaFileUpload={handleMediaFileUpload}
              setuserObj={setuserObj}
              handleValidatePhoneNumber={handleValidatePhoneNumber}
              handleUpdateProfile={handleUpdateProfile}
              setOpenDeleteModal={setOpenDeleteModal}
              error={error}
            />
          ) : // )
            changeScreen === 1 ? (
              <PaymentScreenContent
                paymentMethodArr={paymentMethodArr}
                makeDefault={makeDefault}
                handleDeleteCard={handleDeleteCard}
                cardHolderToggle={cardHolderToggle}
                setcardHolderToggle={setcardHolderToggle}
                cardHolderName={cardHolderName}
                setcardHolderName={setcardHolderName}
                userProfileInfo={userProfileInfo}
                setAddStripe={setAddStripe}
                setstripeLoader={setstripeLoader}
                buttonClicked2={buttonClicked2}
                setButtonClicked2={setButtonClicked2}
                stripeTestPromise={stripeTestPromise}
                stripeloader={stripeloader}
              />
            ) : (
              <FriendReferralsScreenContent
                userObj={userObj}
                success={success}
                Error={Error}
                referralEmail={referralEmail}
                setreferralEmail={setreferralEmail}
                seterror={seterror}
                error={error}
                handleReferAFriend={handleReferAFriend}
                loader={loader}
              />
            )}
        </div>
      </div>

    </>
  );
};

export default UserProfile;
